export interface EventsAdmin {
    id: string;
    channel_id: string;
    name: string;
    product: string;
    creationDate?: string; // This will be mapped from state_changed_at
    eventName: string;
    description?: string;
    schemaId?: string;
    associatedProduct: string;
    associatedChannel: string;
    url: string; // This will be mapped from url
    createdBy: string;
    endpoint_state: string; // This will be mapped from endpoint_state
    distribution_attributes: {
      id: string;
      field: string;
      operator: string;
      value: string;
      group: string;
    }[];
    ordering_enabled: boolean;
  }

  export enum EventStatus {
    Healthy,
		Unhealthy,
		Disabled
  }